import { PropsWithChildren } from "react";
import { TodaysBookedVisits } from "render/hooks/useTodaysBookedVisits";
import { ScheduleUnavailable } from "render/ui/presentation/ScheduleUnavailable";
import { SpinningLoader } from "render/ui/presentation/SpinningLoader";
import styles from "./styles.module.sass";

interface ScheduleGateProps {
  schedule: TodaysBookedVisits;
  // Anything else the list needs before it can be read, such as the rooms its
  // visits are grouped by.
  busy?: boolean;
}

/**
 * The three states a screen built on today's schedule has to tell apart: still
 * loading, unreadable, and readable.
 *
 * Shared by both of them so an unreadable day cannot end up an error on one
 * screen and an empty list on the other.
 */
export function ScheduleGate({
  schedule,
  busy = false,
  children,
}: PropsWithChildren<ScheduleGateProps>) {
  if (schedule.isPending || busy) {
    return (
      <div className={styles.loader}>
        <SpinningLoader success={false} />
      </div>
    );
  }

  if (schedule.isError) {
    return <ScheduleUnavailable onRetry={schedule.retry} />;
  }

  return <>{children}</>;
}
